module.exports = __webpack_public_path__ + "static/media/play.b34a8d1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/play.svg
// module id = 1576
// module chunks = 1